module.exports = __webpack_public_path__ + "img/teste2.f23eea1d.jpeg";